/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _createForOfIteratorHelper from "@babel/runtime-corejs3/helpers/esm/createForOfIteratorHelper";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";

/** @module core/modules/number-utils/first-available-integer */
import { dedupe } from '../../array-utils/internals/dedupe.js';
/**
 * @description Returns the first available integer in numerical order inside the input array.
 * @param {Array<number>} input - Input array.
 * @returns {number} First available integer.
 */

function firstAvailableInteger(input) {
  var _context,
      _this = this,
      _context2;

  var count = 0;
  input = _sortInstanceProperty(_context = dedupe(input)).call(_context, _bindInstanceProperty(_context2 = function _context2(a, b) {
    _newArrowCheck(this, _this);

    return a - b;
  }).call(_context2, this));

  var _iterator = _createForOfIteratorHelper(input),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var num = _step.value;

      if (num !== count) {
        return count;
      }

      count++;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return count;
}

export { firstAvailableInteger };